import React, { useEffect } from 'react'
import { User } from './types'
import { signOut } from 'next-auth/react'
import { useUserSession } from './hooks/useUserSession'
import { differenceInSeconds, fromUnixTime } from 'date-fns'
import { useRouter } from 'next/router'

const UserContext = React.createContext<User | null | undefined>(undefined)

export const useUser = () => {
    const context = React.useContext(UserContext)

    if (context === undefined) {
        throw new Error('useUser must be used within a UserProvider')
    }

    return context
}

export const UserProvider: React.FC<{ user?: User | null }> = ({ user, children }) => {
    const [session, , update] = useUserSession()
    const router = useRouter()

    useEffect(() => {
        if (session == null) {
            return
        }

        const intervalTimeout = 2 * 1000 // 2 seconds in milliseconds
        const expirationThreshold = 5 * 60 // 5 minutes in seconds

        const interval = setInterval(async () => {
            const expireInSeconds = differenceInSeconds(fromUnixTime(session.accessTokenExpires), new Date())

            // console.log(`access token expires ${session.accessTokenExpires}, in ${expireInSeconds} seconds`)

            if (expireInSeconds <= expirationThreshold) {
                //  console.log('token will expire, signing out')
                // refresh next auth session, this will refresh the token
                // see https://github.com/sowee15/locations-web/blob/9e745e99e9bcf5e1ae196064ad7210bc6cc9a318/src/pages/api/auth/%5B...nextauth%5D.tsx#L435
                await update()
                // signOut()
            }
        }, intervalTimeout)

        return () => {
            clearInterval(interval)
        }
    }, [router, session, update])

    return <UserContext.Provider value={user}>{children}</UserContext.Provider>
}
